import { useEffect } from 'react'
import getRoutes from 'utils/routes'
import { useStore } from 'utils/store'
import { initializeAuth } from 'plugins/auth'
import { useLocation, useNavigate } from 'react-router-dom'

export default function App() {
  const AppRoutes = getRoutes()
  // const user = useStore(state => state.user)
  // const loading = useStore(state => state.loading)
  // const location = useLocation()
  // const navigate = useNavigate()

  initializeAuth()

  // useEffect(() => {
  //   if (!loading && !user) {
  //     if (
  //       !location.pathname.includes('email-sign-in') &&
  //       !location.pathname.includes('email-verification')
  //     )
  //       navigate('/email-sign-in')
  //   }
  // }, [loading, location, user])

  useEffect(() => {
    const setMobile = () =>
        useStore.setState({ isMobile: window.innerWidth < 1000 }),
      setScroll = () => useStore.setState({ scrollPosition: window.scrollY })

    window.addEventListener('resize', setMobile)
    window.addEventListener('scroll', setScroll)

    setMobile()
    setScroll()

    return () => {
      window.removeEventListener('resize', setMobile)
      window.removeEventListener('scroll', setScroll)
    }
  }, [])

  return <AppRoutes />
}
